import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  class: "person-tag-avatar"
};
const _hoisted_3 = {
  class: "person-tag-avatar-char"
};
const _hoisted_4 = {
  class: "person-tag-name"
};
import { computed } from 'vue';
import { useFormSize } from 'element-plus';
export default {
  __name: 'ExternalPersonTag',
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formSize = useFormSize();
    const sizeClass = computed(() => {
      const s = formSize.value || 'default';
      if (s === 'small') return 'is-small';
      if (s === 'large') return 'is-large';
      return 'is-default';
    });
    const displayName = computed(() => props.name || '未知人员');
    const firstChar = computed(() => {
      const s = String(displayName.value || '');
      return s.charAt(0) || '?';
    });
    const onClose = () => emit('close', props.id);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["person-tag", [sizeClass.value, {
          'is-disabled': __props.disabled
        }]]),
        title: displayName.value
      }, [_createElementVNode("span", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(firstChar.value), 1)]), _createElementVNode("span", _hoisted_4, _toDisplayString(displayName.value), 1), __props.closable && !__props.disabled ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "person-tag-close",
        "aria-label": "移除",
        onClick: _withModifiers(onClose, ["stop"])
      }, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2.5",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])) : _createCommentVNode("", true)], 10, _hoisted_1);
    };
  }
};